"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isElementOverflowing;
function isElementOverflowing(element, isVertical) {
  return element ? isVertical ? (element === null || element === void 0 ? void 0 : element.scrollHeight) > (element === null || element === void 0 ? void 0 : element.clientHeight) : (element === null || element === void 0 ? void 0 : element.scrollWidth) > (element === null || element === void 0 ? void 0 : element.clientWidth) : false;
}